"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'microphone.access.denied': 'Dostęp do mikrofonu został odmówiony. Proszę zezwolić na dostęp do mikrofonu, aby korzystać z funkcji głosowych.',
};
